import { useUIColors } from '@/core/hooks';
import SignatureSvg from '@assets/images/svg/signature.svg';
import React from 'react';
import { View } from 'react-native';

export interface SignatureIconProps {
    size?: number;
    color?: string;
}

export const SignatureIcon = React.memo<SignatureIconProps>(function SignatureIcon({
    size = 20,
    color = '#333333',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <SignatureSvg width={size} height={size} color={color} />
        </View>
    );
});

export default SignatureIcon;
